module.exports = __webpack_public_path__ + "static/media/Coming in Out.69febb4e.jpg";